import { CloseOutlined } from '@ant-design/icons';
import { CreateServiceGroupForm, DrawerCloseButton } from '@components';
import { useView } from '@hooks';
import { L } from '@lib';
import { Drawer } from 'antd';
import React from 'react';

interface IProps {
  open: boolean;
  onClose: () => void;
  onCreated?: (id: number) => void;
}

export const ServiceGroupCreateDrawer: React.FC<IProps> = ({ open, onClose, onCreated }) => {
  const { isMobile } = useView();

  return (
    <Drawer
      title={L('New service category')}
      open={open}
      onClose={onClose}
      placement="right"
      width={isMobile ? '100%' : 480}
      destroyOnHidden
      closable={false}
      extra={<DrawerCloseButton icon={<CloseOutlined />} onClick={onClose} />}
    >
      <CreateServiceGroupForm handleSelect={onCreated} onCancel={onClose} />
    </Drawer>
  );
};
